import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "Api/Auth";

const DeepLinkHandler = () => {
  const navigate = useNavigate();

    useEffect(() => {
      const hash = window.location.hash;
      const queryString = hash.includes("?")
        ? hash.split("?")[1]
        : "";
      const params = new URLSearchParams(queryString);
      const rawData = params.get("route");

      let web, mobile, redirect;

      // PARSE BACKEND DATA
      let parsed = {};
      try {
        const decoded = atob(rawData);
        parsed = JSON.parse(decoded);
      } catch (e) {
        console.log("Invalid data format");
      }

      web = parsed?.web;
      mobile = parsed?.mobile;
      redirect = parsed?.redirect;

      // VALIDATION
      if (!web && !mobile) {
        navigate("/no-page-found");
        return;
      }

      const isAndroid = /Android/i.test(navigator.userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      const shouldRedirectToApp = Number(redirect) === 1;

      // MOBILE LINK (ENV SCHEME)
      const baseScheme = process.env.REACT_APP_DEEP_LINK_SCHEME;

      const mobileRoute =
        `${baseScheme}${(mobile ?? "")}`;

      // MOBILE FLOW
      if ((isAndroid || isIOS) && shouldRedirectToApp) {

        const playStoreUrl =
          "https://play.google.com/store/apps/details?id=nl.clooser.appclooser";

        const appStoreUrl =
          "https://apps.apple.com/nl/app/clooser-nl/id6476490496";

           window.location.replace(mobileRoute)
          const fallbackTimer = setTimeout(() => {
            if (isAndroid) window.location.replace(playStoreUrl);
            else if (isIOS) window.location.replace(appStoreUrl);
          }, 2000);

        return () => clearTimeout(fallbackTimer);
      }

      // WEB FLOW 
      const isLoggedIn = AuthService.checkUserLoggedIn();

      if (!isLoggedIn) {
        localStorage.setItem(
          "redirectAfterLogin",
          JSON.stringify({ web, mobile })
        );
        navigate("/login");
        return;
      }

      navigate(web);
    }, [navigate]);


  return <div>.</div>;
};

export default DeepLinkHandler;